import styled from 'styled-components'
import { HiMiniChatBubbleLeftRight } from 'react-icons/hi2'
import { device } from '../../../breakpoints'
import { useMemo } from 'react'
import { examplesText } from './texts'
import { GrPowerReset } from 'react-icons/gr'
import { useState } from 'react'
import { useTransition, animated } from '@react-spring/web'
import { Tooltip } from './Tooltip'

const Examples = ({ handleClick }: { handleClick: (text: string) => void }) => {
  const [pickIndex, setPickIndex] = useState<number>(0)
  const [showTooltip, setShowTooltip] = useState<boolean>(false)
  const isMobile = window.innerWidth < 768

  // Shuffle the examples
  const randomExamples = useMemo(
    () => examplesText.sort(() => 0.5 - Math.random()),
    []
  )

  // Pick two examples
  const selectedExamples = useMemo(
    () => randomExamples.slice(pickIndex, pickIndex + 2),
    [pickIndex, randomExamples]
  )

  const transitions = useTransition(selectedExamples, {
    from: { opacity: 0, transform: 'translate3d(0, 10px, 0)' },
    enter: { opacity: 1, transform: 'translate3d(0, 0, 0)' },
  })

  return (
    <Container>
      <MainTitle>Trouvez une série</MainTitle>
      <Title>Par exemple</Title>
      <ExamplesContainer>
        {transitions((style, text) => (
          <ExampleContainer
            style={style}
            onClick={() => {
              handleClick(text)
            }}
          >
            <Example>
              <Icon />
              {text}
            </Example>
          </ExampleContainer>
        ))}
        <ResetButtonContainer>
          <ResetButton
            data-tooltip-id='new-examples'
            data-tooltip-content="Plus d'exemples"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onClick={() => {
              const newPickIndex = pickIndex + 2
              setPickIndex(
                newPickIndex < examplesText.length ? newPickIndex : 0
              )
            }}
          >
            <Tooltip show={!isMobile && showTooltip} text="Plus d'exemples" />
            <GrPowerReset />
          </ResetButton>
        </ResetButtonContainer>
      </ExamplesContainer>
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.colorText};
`

const ExamplesContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    flex-direction: column;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    flex-direction: row;
  }
`

const ResetButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`

const ResetButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 0.85em;
  position: relative;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    svg {
      margin-right: 0.5rem;
    }
  }

  @media ${device.tablet}, @media ${device.laptop} {
    svg {
      margin-right: 0;
    }
  }

  // &:after {
  //   @media ${device.mobileS},
  //     @media ${device.mobileM},
  //     @media ${device.mobileL} {
  //     content: "Plus d'exemples";
  //   }

  //   @media ${device.tablet}, @media ${device.laptop} {
  //     content: '';
  //   }
  // }
`

const ExampleContainer = styled(animated.div)`
  flex: 1;
`

const Icon = styled(HiMiniChatBubbleLeftRight)`
  position: absolute;
  left: 1.75rem;
  top: 50%;
  font-size: 2rem;
  color: ${({ theme }) => theme.colorText};
  transform: translateY(-50%);
`

const Title = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
`

const MainTitle = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.25rem;
  font-family: var(--font-sole);
`

const Example = styled.div`
  position: relative;
  padding: 1.35rem;
  border: 1px solid ${({ theme }) => theme.colorGrey};
  // box-shadow: 0 0 15px ${({ theme }) => theme.colorGreyLight};
  background-color: ${({ theme }) => `${theme.colorGreyLight}`};
  border-radius: 10px;
  // margin-top: 1rem;
  padding-left: 5.5rem;
  line-height: 1.3;
  font-size: 1.5rem;
  font-family: var(--font-plex);
  -webkit-font-smoothing: antialiased;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
  color: ${({ theme }) => theme.colorText};

  &:hover {
    background-color: ${({ theme }) => `${theme.colorGreyLight}99`};
  }
`

export default Examples
